import { useState } from 'react';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormTimeField from 'modules/ui/editform/fields/EditFormTimeField';
import PredictionDeviceEditService from '../service/PredictionDeviceEditService';

const getPredictionTypeItems = formData =>
	formData.entityMap?.predictionType || formData.enumMap?.predictionType || [];

const getPredictionTypeFieldType = formData =>
	!formData.entityMap?.predictionType && formData.enumMap?.predictionType ? 'enum' : undefined;

const config = data => {
	const predictionTypeFieldType = getPredictionTypeFieldType(data.formData);

	return {
		key: 'predictionDeviceEditForm',
		text: 'Prediction Device',
		textKey: 'predictionDevice',
		service: PredictionDeviceEditService,
		editableAccess: data.formData.editableAccess,
		editableFields: data.formData.editableFields,
		fields: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'project',
				text: 'Project',
				textKey: 'project',
				component: EditFormSelectField,
				items: data.formData.entityMap?.project || [],
				required: true
			},
			{
				key: 'deviceType',
				text: 'Device Type',
				textKey: 'deviceType',
				component: EditFormSelectField,
				items: data.formData.entityMap?.deviceType || [],
				required: true
			},
			{
				key: 'sourceDevice',
				text: 'Source Device',
				textKey: 'sourceDevice',
				component: EditFormSelectField,
				items: data.formData.entityMap?.sourceDevice || data.formData.entityMap?.device || [],
				required: true
			},
			{
				key: 'predictionType',
				text: 'Prediction Type',
				textKey: 'predictionType',
				component: EditFormSelectField,
				type: predictionTypeFieldType,
				items: getPredictionTypeItems(data.formData),
				required: true
			},
			{
				key: 'lastSeen',
				text: 'Last Seen',
				textKey: 'lastSeen',
				component: EditFormTimeField,
				readOnly: true
			}
		]
	};
};

function PredictionDeviceEditForm() {
	const [formData, setFormData] = useState(null);
	if (formData == null) {
		PredictionDeviceEditService.getFormData().then(result => setFormData(result));
		return <></>;
	}
	const myConfig = config({ formData });
	return <EditFormPage config={myConfig} />;
}

export default PredictionDeviceEditForm;
